export function showWelcomePanel() {
  return new Promise((resolve) => {
    const panel = document.getElementById('welcome-panel');
    if (!panel) return resolve('continue');

const STORAGE_KEY = 'samappVisited';

    const hasVisited = localStorage.getItem(STORAGE_KEY);
    if (hasVisited) return resolve('continue');

    panel.classList.remove('hidden');

    document.getElementById('welcome-continue').addEventListener('click', () => {
      localStorage.setItem(STORAGE_KEY, 'true');
      panel.classList.add('hidden');
      resolve('continue');
    });

    document.getElementById('welcome-exit').addEventListener('click', () => {
      resolve('exit');
    });

    // PWA install prompt logic
    let deferredPrompt;
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      deferredPrompt = e;
      // document.getElementById('install-btn').style.display = 'block';
    });

    document.getElementById('install-btn').addEventListener('click', async () => {
      if (deferredPrompt) {
        deferredPrompt.prompt();
        const choice = await deferredPrompt.userChoice;
        if (choice.outcome === 'accepted') {
          console.log('[Welcome] User accepted install');
        } else {
          console.log('[Welcome] User dismissed install');
        }
        deferredPrompt = null;
        document.getElementById('install-btn').style.display = 'none';
      }
    });
  });
}